import { useEffect } from "react";
import type { CSSProperties } from "react";
import type { PoolTabletConfig } from "../scenario/types";

/**
 * Lock/home chrome for the pool-walkable iPad. The App-level `.screen-power`
 * gate (SCREEN_KINDS) is what "switches it on" — this component only mounts
 * after that click. When `style` is set, App glued us to the projected
 * tablet quad (GltfScreenOverlay); otherwise we fill the `--scr-*` box.
 */
export function PoolTablet({
  config,
  onContinue,
  style,
}: {
  config: PoolTabletConfig;
  onContinue: () => void;
  style?: CSSProperties;
}) {
  const time = config.lockTime ?? "11:42";
  const date = config.lockDate ?? "Sunday, 16 August";
  const owner = config.ownerName ?? "Personal iPad";
  const cta = config.continueLabel ?? "Continue";

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onContinue();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onContinue]);

  return (
    <div className={`pool-ipad${style ? " pool-ipad--glued" : ""}`} style={style} aria-label={owner}>
      <div className="pool-ipad-notch" aria-hidden />
      <div className="pool-ipad-lock">
        <div className="pool-ipad-date">{date}</div>
        <div className="pool-ipad-time">{time}</div>
        <div className="pool-ipad-owner">{owner}</div>
      </div>
      <button type="button" className="pool-ipad-cta cf-pulse-target" onClick={onContinue}>
        {cta}
      </button>
    </div>
  );
}
